"use client";

import { FormattedMessage } from "react-intl";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "../ui/dialog";
import { TwoFactorAuthChallengeModalBody } from "../TwoFactorAuthChallengeModalBody/ModalBody";

/**
 * @typedef {object} ApiFetcherProviderModalProps
 * @prop {import("../../hooks/useApiFetcher").TwoFactorAuthChallengeData | null} challengeData
 * @prop {(isSuccess: boolean) => void} resolve
 * @prop {boolean} openModal
 * @prop {(details: import("@chakra-ui/react").DialogOpenChangeDetails) => void} handleOpenChange
 */
/**
 * @param {ApiFetcherProviderModalProps} props
 */
export function ApiFetcherProviderModal({
  challengeData,
  resolve,
  openModal,
  handleOpenChange,
}) {
  // #region return
  return (
    <DialogRoot
      open={openModal}
      onOpenChange={handleOpenChange}
      closeOnInteractOutside={false}
    >
      <DialogContent>
        <DialogCloseTrigger />

        <DialogHeader>
          <DialogTitle>
            <FormattedMessage defaultMessage="Vérification en deux étapes" />
          </DialogTitle>
        </DialogHeader>

        <DialogBody>
          {challengeData && (
            <TwoFactorAuthChallengeModalBody
              resolve={resolve}
              challengeData={challengeData}
            />
          )}
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
}
